import { useFormFieldContext } from './form-field-context';

/**
 * Shared accessibility wiring for a FormField control: the control id, the
 * aria-describedby chain (description + message), and aria-invalid. Every
 * control spreads these so labels, help text, and errors are announced.
 */
export function useFieldAria(): {
  id: string;
  'aria-describedby': string;
  'aria-invalid': boolean;
} {
  const { formItemId, formDescriptionId, formMessageId, error } = useFormFieldContext();
  return {
    id: formItemId,
    'aria-describedby': error
      ? `${formDescriptionId} ${formMessageId}`
      : formDescriptionId,
    'aria-invalid': !!error,
  };
}
